import { env } from "../config/config";

export const enviroments = {
    get base() {
        return env.config.tabletopCoreApiUrl;
    },
    get auth() {
        return `${env.config.tabletopCoreApiUrl}/auth`;
    },
};

export const apiUrl = (path: string) => {
    const suffix = path.startsWith("/") ? path : `/${path}`;
    return `${enviroments.base}${suffix}`;
};
